import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {CardContent, CardActionArea} from 'views/components';
import {Typography, Stack} from 'views/components';

import {Translate} from 'views/module';

const Card = (props) => {
  const item = props.item;

  const caregiverRn = item.caregiverRn;
  const caregiverName = item.caregiverName;
  const status = item.status;

  const clients = Object.values(item.clients || {});

  return (
    <React.Fragment>
      <CardActionArea
        sx={{
          textAlign: 'left',
        }}
        to={`/caregiver/${caregiverRn}`}
      >
        <CardContent>
          <Typography variant="h5" component="div">
            {caregiverName}
          </Typography>
          <Stack direction={'row'}>
            <Typography sx={{fontSize: 14}} color="text.secondary" gutterBottom>
              <Translate expression={`caregiver.CaregiverList.CaregiverStatus`} />
              <Translate expression={`caregiver.Status.${status}.Title`} />
            </Typography>
          </Stack>
          {
            !!clients.length && (
              <Stack direction="row" flexWrap="wrap" gap={0.5}>
                <Typography sx={{fontSize: 14}} color="text.secondary" gutterBottom>
                  <Translate expression={`caregiver.CaregiverList.Clients`} />
                  {
                    clients.map((client, index) => (
                      <React.Fragment key={index}>
                        {client.clientName}
                        {
                          index < clients.length - 1 && (
                            <>, </>
                          )
                        }
                      </React.Fragment>
                    ))
                  }
                </Typography>
              </Stack>
            )
          }
        </CardContent>
      </CardActionArea>
    </React.Fragment>
  );
};

Card.propTypes = {
  item: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, dispatch)(React.memo(Card));
